import src from "IMAGE";
export default { src, width: 132, height: 86, blurWidth: 0, blurHeight: 0};
